import { createTheme, Theme as MaterialUITheme } from '@material-ui/core';

declare module '@material-ui/core' {
  interface Theme {
    custom: {
      primaryGradient: string;
      primaryGradientHover: string;
    };
  }
  interface ThemeOptions {
    custom: {
      primaryGradient: string;
      primaryGradientHover: string;
    };
  }
}

export const theme = createTheme({
  palette: {
    common: {
      black: '#000000DE',
      white: '#FFFFFF',
    },
    // blue
    primary: {
      main: '#3370FF',
      light: '#6B9AFF',
      dark: '#2858CC',
      contrastText: '#FFFFFF',
    },
    // blue-grey
    secondary: {
      main: '#607D8B',
      light: '#8EACBB',
      dark: '#455A64',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#F79804DE',
      contrastText: '#fff',
    },
    info: {
      main: '#3B82F6',
      contrastText: '#707070',
    },
    error: {
      main: '#D32F2F',
      light: '#EF5350',
      dark: '#C62828',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#4CAF51',
      contrastText: '#707070',
    },
    grey: {
      100: '#F9F9F9',
      200: '#F2F2F2',
      300: '#F9F9F9',
      400: '#B5B5B5',
      500: '#B5B5B5',
      600: '#858585',
      700: '#686868',
      800: '#3C3C3C',
      900: '#000000',
    },
    text: {
      primary: '#212121',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  custom: {
    // This is using as background color gradient
    primaryGradient: 'linear-gradient(270deg, #6B9AFF 0%, #3370FF 100%)',
    primaryGradientHover: 'linear-gradient(270deg, #2858CC 0%, #1A4ACC 100%)',
  },
  typography: {
    fontFamily: 'Inter',
    h1: {
      fontSize: '36px',
      fontFamily: 'Inter',
      lineHeight: '48px',
      fontWeight: 700,
    },
    h2: {
      fontSize: '36px',
      fontFamily: 'Inter',
      lineHeight: '48px',
      fontWeight: 400,
    },
    h3: {
      fontSize: '24px',
      fontFamily: 'Inter',
      lineHeight: '48px',
      fontWeight: 700,
    },
    h4: {
      fontSize: '24px',
      fontFamily: 'Inter',
      lineHeight: '36px',
      fontWeight: 600,
    },
    h5: {
      fontSize: '16px',
      fontFamily: 'Inter',
      lineHeight: '24px',
      fontWeight: 600,
    },
    h6: {
      fontSize: '16px',
      fontFamily: 'Inter',
      lineHeight: '24px',
      fontWeight: 400,
    },
    caption: {
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: 600,
    },
    button: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 500,
      letterSpacing: '0.46px',
      textTransform: 'capitalize',
    },
    subtitle1: {
      fontSize: '24px',
      lineHeight: '36px',
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: 400,
    },
    body1: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 400,
    },
    body2: {
      fontSize: '14px',
      lineHeight: '22px',
      fontWeight: 400,
    },
    overline: {
      fontSize: '12px',
      lineHeight: '20px',
      fontWeight: 400,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 15,
      },
    },
  },
});

export type Theme = MaterialUITheme;
export default theme;
